import request from "./api.js"

const baseUrl = 'https://admin.huimiaokeji.com'; // 设置环境接口的域名
// const baseUrl = 'http://localhost:8087';

export function getUrlParams(url, data) {
	if (data) {
		let u = "?"
		for (let key in data) {  
		  if (data.hasOwnProperty(key) && data[key]) {
			 if (u != "?") {
				 u += "&";
			 }
			 u += key + "=" + data[key];
		  }
		}
		return url += u;
	}
	return url;
}
 
export function getArticleList(data) {
    return request({
        url: getUrlParams(baseUrl + `/appApi/bus/free/articleList`, data),
        method: 'get',
        timeout: 20000,
    })
}

export function getArticleDetail(data) {
    return request({
        url: getUrlParams(baseUrl + `/appApi/bus/free/articleDetail`, data),
        method: 'get',
        timeout: 20000,
    })
}

export function getSendSms(phone) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/sendSms/` + phone),
		method: 'post',
		timeout: 20000,
	})
}

export function getCaseList() {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/getCaseList`),
		method: 'get',
		timeout: 20000,
	})
}

export function addContactUs(data) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/addContactUs`, data),
		method: 'get',
		timeout: 20000,
	})
}

export function getIndustryInfo(data) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/getIndustryInfo`, data),
		method: 'get',
		timeout: 20000,
	})
}

export function getDetailById(data) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/getDetailById`, data),
		method: 'get',
		timeout: 20000,
	})
}

export function getCaseByCaseId(data) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/getCaseByCaseId`, data),
		method: 'get',
		timeout: 20000,
	})
}

export function getAboutInfo(data) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/getAboutInfo`, data),
		method: 'get',
		timeout: 20000,
	})
}

export function qryBannerInfo(type) {
	return request({
		url: getUrlParams(baseUrl + `/appApi/bus/free/qryBannerInfo?type=${type}`),
		method: 'get',
		timeout: 20000,
	})
}


// WEBPACK FOOTER //
// ./src/api/index.js